export enum QUERY_KEYS {
  ORGANIZATIONS = 'ORGANIZATIONS',
  USERS = 'USERS',
}

export default QUERY_KEYS
